import React, { useEffect, useState } from 'react';
import Board from './components/Board';
import { saveNotes, loadNotes, uid } from './utils';

function App() {
  const [notes, setNotes] = useState([]);
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');

  // Load notes from localStorage on first render
  useEffect(() => {
    setNotes(loadNotes());
  }, []);

  // Save notes to localStorage whenever they change
  useEffect(() => {
    saveNotes(notes);
  }, [notes]);

  function addNote(e) {
    e.preventDefault();
    if (!title.trim() && !body.trim()) return;

    const now = Date.now();
    const newNote = {
      id: uid(),
      title: title.trim(),
      body: body.trim(),
      createdAt: now,
      updatedAt: now,
    };

    setNotes([newNote, ...notes]);
    setTitle('');
    setBody('');
  }

  function deleteNote(id) {
    setNotes(notes.filter((n) => n.id !== id));
  }

  function updateNote(updated) {
    setNotes(notes.map((n) => (n.id === updated.id ? updated : n)));
  }

  return (
    <div className="app">
      <h1>Sticky Notes Board</h1>

      <form className="form" onSubmit={addNote}>
        <input
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <textarea
          placeholder="Write your note..."
          value={body}
          onChange={(e) => setBody(e.target.value)}
        />
        <button type="submit">Add Note</button>
      </form>

      <Board notes={notes} onDelete={deleteNote} onUpdate={updateNote} />
    </div>
  );
}

export default App;
